<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap class="mb-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <div>
              <h3 class="headline mb-0">{{labels.applicant}}</h3>
            </div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-radio-group :label="labels.appIntStat" v-model="travelForm.applicant.appIntStat" row :error-messages="errors.collect('appIntStat')" data-vv-name="appIntStat" :data-vv-as="labels.appIntStat" v-validate="'required'" @change="doAppIntStat">
                    <v-radio v-for="status in appIntStatList" :key="status.value" :label="status.label" :value="status.value"></v-radio>
                  </v-radio-group>
                </v-flex>
                <v-flex lg6 xs12>
                </v-flex>
                <template v-if="travelForm.applicant.appIntStat === 'E'">
                  <v-flex lg6 xs12>
                    <v-text-field key="coyName" v-model="travelForm.applicant.coyName" :label="labels.coyName" :error-messages="errors.collect('coyName')" data-vv-name="coyName" :data-vv-as="labels.coyName" v-validate="'required|name|max:50'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field v-model="travelForm.applicant.coyRocUen" :label="labels.coyRocUen" :error-messages="errors.collect('coyRocUen')" data-vv-name="coyRocUen" :data-vv-as="labels.coyRocUen" v-validate="'entry|max:20'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field v-model="travelForm.applicant.coyNature" :label="labels.coyNature" :error-messages="errors.collect('coyNature')" data-vv-name="coyNature" :data-vv-as="labels.coyNature" v-validate="'entry|max:128'"></v-text-field>
                  </v-flex>
                </template>
                <template v-else>
                  <v-flex lg6 xs12>
                    <v-autocomplete key="appSalutation" :items="salutationList" v-model="travelForm.applicant.appSalutation" :label="labels.appSalutation" item-text="label" item-value="value" data-vv-name="appSalutation" :data-vv-as="labels.appSalutation" :error-messages="errors.collect('appSalutation')" v-validate="'required'" @input="doSalutation"></v-autocomplete>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appName" v-model="travelForm.applicant.appName" :label="labels.appName" :error-messages="errors.collect('appName')" data-vv-name="appName" :data-vv-as="labels.appName" v-validate="'required|name|max:50'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-text-field key="appNricPassport" v-uppercase="travelForm.applicant.appNricPassport" v-model="travelForm.applicant.appNricPassport" :label="labels.appNricPassport" :error-messages="errors.collect('appNricPassport')" data-vv-name="appNricPassport" :data-vv-as="labels.appNricPassport" v-validate="'required|alpha_num|max:20'"></v-text-field>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <cal-picker key="appDob" v-model="travelForm.applicant.appDob" :label="labels.appDob" v-validate="dobValidation" :data-vv-as="labels.appDob" data-vv-name="appDob" :error-messages="errors.collect('appDob')"></cal-picker>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-radio-group key="appGender" v-model="travelForm.applicant.appGender" row :label="labels.appGender" :error-messages="errors.collect('appGender')" data-vv-name="appGender" :data-vv-as="labels.appGender" v-validate="'required'">
                      <v-radio v-for="gender in genderList" :key="gender.value" :label="gender.label" :value="gender.value"></v-radio>
                    </v-radio-group>
                  </v-flex>
                  <v-flex lg6 xs12>
                    <v-checkbox key="appIsStudent" v-model="travelForm.applicant.appIsStudent" :label="labels.appIsStudent" :error-messages="errors.collect('appIsStudent')" data-vv-name="appIsStudent" :data-vv-as="labels.appIsStudent" hide-details></v-checkbox>
                  </v-flex>
                  <!-- <v-flex lg6 xs12>
                    <v-checkbox key="appIsInsured" v-model="travelForm.applicant.appIsInsured" :label="labels.appIsInsured" :error-messages="errors.collect('appIsInsured')" data-vv-name="appIsInsured" :data-vv-as="labels.appIsInsured" hide-details></v-checkbox>
                  </v-flex> -->
                </template>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appContact}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appEmail" type="email" :label="labels.appEmail" :error-messages="errors.collect('appEmail')" data-vv-name="appEmail" :data-vv-as="labels.appEmail" v-validate="'required|email'" prepend-icon="mdi-email" hint="An email acknowledgement will be sent to this address" :persistent-hint="true"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appMobileNo" v-int-mask="{intScale: 8}" type="tel" :label="labels.appMobileNo" :error-messages="errors.collect('appMobileNo')" data-vv-name="appMobileNo" :data-vv-as="labels.appMobileNo" v-validate="'numeric|required'" hint="Mobile No. is required to receive SMS confirmation" :persistent-hint="true" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appTelNo1" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo1" :error-messages="errors.collect('appTelNo1')" data-vv-name="appTelNo1" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appTelNo2" v-int-mask="{intScale: 8}" type="tel" :label="labels.appTelNo2" :error-messages="errors.collect('appTelNo2')" data-vv-name="appTelNo2" :data-vv-as="labels.appTelNo1" v-validate="'numeric'" prepend-icon="mdi-phone"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.appAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appAdd3" :label="labels.appAdd3" :error-messages="errors.collect('appAdd3')" data-vv-name="appAdd3" :data-vv-as="labels.appAdd3" prefix="#" v-validate="'unit_no|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appPostalCode" :label="labels.appPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('appPostalCode')" data-vv-name="appPostalCode" :data-vv-as="labels.appPostalCode" v-validate="'required|numeric'" :loading="appPostalCodeLoading" @change="doAppAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appAdd1" :label="labels.appAdd1" :error-messages="errors.collect('appAdd1')" data-vv-name="appAdd1" :data-vv-as="labels.appAdd1" v-validate="'required|entry|max:30'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appAdd2" :label="labels.appAdd2" :error-messages="errors.collect('appAdd2')" data-vv-name="appAdd2" :data-vv-as="labels.appAdd2" v-validate="'required|entry|max:255'"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.appAdd4" :label="labels.appAdd4" :error-messages="errors.collect('appAdd4')" data-vv-name="appAdd4" :data-vv-as="labels.appAdd4" v-validate="'entry|max:255'"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-title>
            <div class="body-2">{{labels.mailAddress}}</div>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-checkbox v-model="travelForm.applicant.mailAdd" :label="labels.mailAdd" data-vv-name="mailAdd" :data-vv-as="labels.mailAdd" :error-messages="errors.collect('mailAdd')" @change="doMailAdd" hide-details></v-checkbox>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.mailAdd3" :label="labels.mailAdd3" :error-messages="errors.collect('mailAdd3')" data-vv-name="mailAdd3" :data-vv-as="labels.mailAdd3" prefix="#" v-validate="'entry|max:30'" :readonly="travelForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.mailPostalCode" :label="labels.mailPostalCode" v-int-mask="{intScale: 6}" type="tel" :error-messages="errors.collect('mailPostalCode')" data-vv-name="mailPostalCode" :readonly="travelForm.applicant.mailAdd" :data-vv-as="labels.mailPostalCode" v-validate="'numeric'" :loading="mailPostalCodeLoading" @change="doMailAddress"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.mailAdd1" :label="labels.mailAdd1" :error-messages="errors.collect('mailAdd1')" data-vv-name="mailAdd1" :data-vv-as="labels.mailAdd1" v-validate="'entry|max:30'" :readonly="travelForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.mailAdd2" :label="labels.mailAdd2" :error-messages="errors.collect('mailAdd2')" data-vv-name="mailAdd2" :data-vv-as="labels.mailAdd2" v-validate="'entry|max:255'" :readonly="travelForm.applicant.mailAdd"></v-text-field>
                </v-flex>
                <v-flex lg6 xs12>
                  <v-text-field v-model="travelForm.applicant.mailAdd4" :label="labels.mailAdd4" :error-messages="errors.collect('mailAdd4')" data-vv-name="mailAdd4" :data-vv-as="labels.mailAdd4" v-validate="'entry|max:255'" :readonly="travelForm.applicant.mailAdd"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout row wrap class="mt-3">
      <v-btn round color="primary" @click.prevent="doBack">
        <v-icon left dark>mdi-chevron-left</v-icon>
        Back
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn round color="primary" type="submit" @click.prevent="doProceed">
        Next
        <v-icon right dark>mdi-chevron-right</v-icon>
      </v-btn>
    </v-layout>
  </v-container>
</template>

<script>
import { AGENCY_QUOTATION_LIFECYCLE } from '@/store/types'
import MessageMixin from '@/mixins/message'
import { SaveQuoteMixin } from '../../shared/saveQuoteMixin'
import { salutation, gender, applicantStatus } from '@/const/underwriting'
import toDate from 'date-fns/toDate'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        applicant: 'Applicant',
        appIntStat: 'Applicant Status*',
        appName: 'Name as in NRIC/Passport*',
        appSalutation: 'Salutation*',
        appNricPassport: 'NRIC/Passport*',
        appDob: 'Date of Birth*',
        appGender: 'Gender*',
        appIsStudent: 'Is full time student?',
        appIsInsured: 'Is Insured?',
        appAddress: 'Applicant Address',
        mailAddress: 'Mailing Address',
        appAdd1: 'Block/House No.*',
        appAdd2: 'Street Name*',
        appAdd3: 'Unit No.',
        appAdd4: 'Building Name',
        appPostalCode: 'Postal Code*',
        mailAdd: 'Same as Applicant Address',
        mailAdd1: 'Block/House No.',
        mailAdd2: 'Street Name',
        mailAdd3: 'Unit No.',
        mailAdd4: 'Building Name',
        mailPostalCode: 'Postal Code',
        appContact: 'Contacts',
        appEmail: 'Email*',
        appMobileNo: 'Mobile No.',
        appTelNo1: 'Home No.',
        appTelNo2: 'Office No',
        coyName: 'Name of Company*',
        coyRocUen: 'ROC/UEN',
        coyNature: 'Nature of Business'
      },
      travelForm: {
        applicant: {
          appIntStat: undefined,
          appSalutation: undefined,
          appName: undefined,
          appNricPassport: undefined,
          appDob: undefined,
          appGender: undefined,
          appIsStudent: undefined,
          appIsInsured: undefined,
          appEmail: undefined,
          appMobileNo: undefined,
          appTelNo1: undefined,
          appTelNo2: undefined,
          appPostalCode: undefined,
          appAdd1: undefined,
          appAdd2: undefined,
          appAdd3: undefined,
          appAdd4: undefined,
          mailAdd: undefined,
          mailPostalCode: undefined,
          mailAdd1: undefined,
          mailAdd2: undefined,
          mailAdd3: undefined,
          mailAdd4: undefined,
          coyName: undefined,
          coyRocUen: undefined,
          coyNature: undefined
        }
      },
      appPostalCodeLoading: false,
      mailPostalCodeLoading: false
    }
  },
  computed: {
    globalForm() {
      return this.$store.state.agency.quotation.travelForm
    },
    globalCommonForm() {
      return this.$store.state.agency.quotation.commonForm
    },
    appIntStatList() {
      // Convert object to arr
      let result = []
      Object.keys(applicantStatus).forEach(function (key) {
        const status = applicantStatus[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    salutationList() {
      let result = []
      Object.keys(salutation).forEach(function (key) {
        const status = salutation[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    genderList() {
      let result = []
      Object.keys(gender).forEach(function (key) {
        const status = gender[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    selectedPlan() {
      return this.$store.getters.travelQuoteSelectedPlan
    },
    dobValidation() {
      if (this.selectedPlan && (this.selectedPlan.minInsdAge !== null || typeof this.selectedPlan.minInsdAge !== 'undefined') && this.selectedPlan.maxInsdAge) {
        return { required: true, bday_range: [this.globalCommonForm.startDate, this.selectedPlan.minInsdAge, this.selectedPlan.maxInsdAge] }
      } else {
        // hardCode is cannot find age
        return { required: true, bday_range: [this.globalCommonForm.startDate, 1, 100] }
      }
    }
  },
  watch: {
    'travelForm.applicant.appAdd1': function (value) {
      if (this.travelForm.applicant.mailAdd) {
        this.travelForm.applicant.mailAdd1 = value
      }
    },
    'travelForm.applicant.appAdd2': function (value) {
      if (this.travelForm.applicant.mailAdd) {
        this.travelForm.applicant.mailAdd2 = value
      }
    },
    'travelForm.applicant.appAdd3': function (value) {
      if (this.travelForm.applicant.mailAdd) {
        this.travelForm.applicant.mailAdd3 = value
      }
    },
    'travelForm.applicant.appAdd4': function (value) {
      if (this.travelForm.applicant.mailAdd) {
        this.travelForm.applicant.mailAdd4 = value
      }
    },
    'travelForm.applicant.appPostalCode': function (value) {
      if (this.travelForm.applicant.mailAdd) {
        this.travelForm.applicant.mailPostalCode = value
      }
    }
  },
  methods: {
    doInit() {
      // Default value from vuex store 1st
      // Applicant
      const { applicant } = this.globalCommonForm
      this.travelForm.applicant.appIntStat = applicant.appIntStat
      this.travelForm.applicant.appSalutation = applicant.appSalutation
      this.travelForm.applicant.appName = applicant.appName
      this.travelForm.applicant.appGender = applicant.appGender
      this.travelForm.applicant.appNricPassport = applicant.appNricPassport
      if (applicant.appDob) {
        this.travelForm.applicant.appDob = toDate(applicant.appDob)
      }
      this.travelForm.applicant.appIsStudent = applicant.appIsStudent
      this.travelForm.applicant.appIsInsured = applicant.appIsInsured
      this.travelForm.applicant.appEmail = applicant.appEmail
      this.travelForm.applicant.appMobileNo = applicant.appMobileNo
      this.travelForm.applicant.appTelNo1 = applicant.appTelNo1
      this.travelForm.applicant.appTelNo2 = applicant.appTelNo2
      this.travelForm.applicant.appPostalCode = applicant.appPostalCode
      this.travelForm.applicant.appAdd1 = applicant.appAdd1
      this.travelForm.applicant.appAdd2 = applicant.appAdd2
      this.travelForm.applicant.appAdd3 = applicant.appAdd3
      this.travelForm.applicant.appAdd4 = applicant.appAdd4
      this.travelForm.applicant.mailAdd = applicant.mailAdd
      this.travelForm.applicant.mailPostalCode = applicant.mailPostalCode
      this.travelForm.applicant.mailAdd1 = applicant.mailAdd1
      this.travelForm.applicant.mailAdd2 = applicant.mailAdd2
      this.travelForm.applicant.mailAdd3 = applicant.mailAdd3
      this.travelForm.applicant.mailAdd4 = applicant.mailAdd4
      this.travelForm.applicant.coyName = applicant.coyName
      this.travelForm.applicant.coyRocUen = applicant.coyRocUen
      this.travelForm.applicant.coyNature = applicant.coyNature

      // Default values
      if (!this.travelForm.applicant.appIntStat && this.appIntStatList && this.appIntStatList.length > 0) {
        // Default 1st value if not found
        this.travelForm.applicant.appIntStat = this.appIntStatList[0].value
      }
      if (this.travelForm.applicant.appIsStudent === null || this.travelForm.applicant.appIsStudent === undefined) {
        this.travelForm.applicant.appIsStudent = false
      }
      if (this.travelForm.applicant.appIsInsured === null || this.travelForm.applicant.appIsInsured === undefined) {
        this.travelForm.applicant.appIsInsured = true
      }
    },
    doAppIntStat() {
      // Reset some values
      if (this.travelForm.applicant.appIntStat && this.travelForm.applicant.appIntStat === 'E') {
        this.travelForm.applicant.appSalutation = undefined
        this.travelForm.applicant.appName = undefined
        this.travelForm.applicant.appNricPassport = undefined
        this.travelForm.applicant.appDob = undefined
        this.travelForm.applicant.appGender = undefined
        this.travelForm.applicant.appIsStudent = undefined
        this.travelForm.applicant.appIsInsured = false
      } else if (this.travelForm.applicant.appIntStat && this.travelForm.applicant.appIntStat === 'I') {
        this.travelForm.applicant.coyName = undefined
        this.travelForm.applicant.coyRocUen = undefined
        this.travelForm.applicant.coyNature = undefined
        this.travelForm.applicant.appIsStudent = false
        this.travelForm.applicant.appIsInsured = true
      }
    },
    doSalutation() {
      if (this.travelForm.applicant.appSalutation === 'MR') {
        this.travelForm.applicant.appGender = 'M'
      } else if (this.travelForm.applicant.appSalutation === 'MS' || this.travelForm.applicant.appSalutation === 'MDM' || this.travelForm.applicant.appSalutation === 'MRS') {
        this.travelForm.applicant.appGender = 'F'
      } else {
        if (!this.travelForm.applicant.appGender || this.travelForm.applicant.appGender === null) {
          this.travelForm.applicant.appGender = 'M'
        }
      }
    },
    async doAppAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.appPostalCodeLoading = true
          const expand = {
            postCode: this.travelForm.applicant.appPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.travelForm.applicant.appAdd1 = data.add1
            this.travelForm.applicant.appAdd2 = data.add2
            this.travelForm.applicant.appAdd4 = data.add4
          }
          this.appPostalCodeLoading = false
        } catch (err) {
          this.appPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    async doMailAddress() {
      const apiUrl = this.$store.state.agency.quotation.menu.address
      if (apiUrl) {
        try {
          this.mailPostalCodeLoading = true
          const expand = {
            postCode: this.travelForm.applicant.mailPostalCode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result
          if (data) {
            this.travelForm.applicant.mailAdd1 = data.add1
            this.travelForm.applicant.mailAdd2 = data.add2
            this.travelForm.applicant.mailAdd4 = data.add4
          }
          this.mailPostalCodeLoading = false
        } catch (err) {
          this.mailPostalCodeLoading = false
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    },
    doMailAdd() {
      this.travelForm.applicant.mailAdd1 = this.travelForm.applicant.appAdd1
      this.travelForm.applicant.mailAdd2 = this.travelForm.applicant.appAdd2
      this.travelForm.applicant.mailAdd3 = this.travelForm.applicant.appAdd3
      this.travelForm.applicant.mailAdd4 = this.travelForm.applicant.appAdd4
      this.travelForm.applicant.mailPostalCode = this.travelForm.applicant.appPostalCode
    },
    doBack() {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 2)
      this.$router.push({ name: 'travelQuotePlans' })
    },
    doProceed() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if ((this.travelForm.applicant.appMobileNo && this.travelForm.applicant.appMobileNo !== '') ||
            (this.travelForm.applicant.appTelNo1 && this.travelForm.applicant.appTelNo1 !== '') ||
            (this.travelForm.applicant.appTelNo2 && this.travelForm.applicant.appTelNo2 !== '')) {
            this.$store.dispatch('travelQuoteApplicant', this.travelForm)
            this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 4)
            this.$router.push({ name: 'travelQuoteInsured' })
          } else {
            this.promptFieldCheck()
            this.errorMessage('At least one of the contact number is required')
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doPartialSave() {
      // No mandatory validation here. Commit whatever thats on screen and do neccesary actions before saving
      // Must return true/false
      try {
        this.$store.dispatch('travelQuoteApplicant', this.travelForm)
        await this.$store.dispatch('saveQuote')
        return true
      } catch (err) {
        return false
      }
    }
  },
  beforeMount() {
    // Check quote lifecycle (might be using back link or url)
    if (this.$store.state.agency.quotation.quoteLifeCycle !== 3) {
      this.$store.commit(AGENCY_QUOTATION_LIFECYCLE, 3)
    }
    this.doInit()
  },
  mixins: [
    MessageMixin,
    SaveQuoteMixin
  ]
}
</script>

<style lang="scss">
</style>
